const emcStatsDefaultState = {
    data: [],
    emcStat: {},
    loading: false,
    error: false,
    success: false,
    successMessage: '',
    errorMessage: null
};

const emcStatsReducer = (state = emcStatsDefaultState, action) => {
    switch (action.type) {
        case 'START_GET_EMC_STAT':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'GET_EMC_STAT_SUCCESS':
            return {
                ...state,
                emcStat: action.emcStat,
                loading: false,
                error: false,
                errorMessage: null,
            };
        case 'START_GET_EMC_STATS':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
                success: false
            };
        case 'GET_EMC_STATS_SUCCESS':
            return {
                ...state,
                data: action.emcStats,
                loading: false,
                error: false,
                errorMessage: null,
            };
        case 'CREATE_EMC_STAT_SUCCESS':
            return {
                ...state,
                data: action.emcStat,
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'News Alert has been updated',
            };
        case 'START_EMC_STAT_UPDATE':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'UPDATE_EMC_STAT_SUCCESS':
            return {
                ...state,
                data: action.emcStatDetails,
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'Microsite has been updated',
            };
        case 'START_REMOVE_EMC_STAT':
            return {
                ...state,
                loading: true,
                success: false,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'REMOVE_EMC_STAT_SUCCESS':
            return {
                ...state,
                data: state.data.filter(emailContentStat => emailContentStat.id !== Number(action.emailContentStatId)),
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'Your ads have been removed!',
            };
        case 'EMC_STAT_CLEAR_SUCCESS':
            return {
                ...state,
                success: false
            };
        case 'SHOW_ERROR':
            return {
                ...state,
                loading: false,
                error: true,
                successMessage: '',
                errorMessage: action.errorMessage
            };
        default:
            return state;
    }
};

export default emcStatsReducer;